import _createForOfIteratorHelper from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module ui/search/searchresultsview
 */
import View from '../view.js';
import { FocusTracker } from '@ckeditor/ckeditor5-utils';
import { default as FocusCycler } from '../focuscycler.js';
/**
 * A sub-component of {@link module:ui/search/text/searchtextview~SearchTextView}. It hosts the filtered and the information views.
 */
var SearchResultsView = /*#__PURE__*/function (_View) {
  _inherits(SearchResultsView, _View);
  var _super = _createSuper(SearchResultsView);
  /**
   * @inheritDoc
   */
  function SearchResultsView(locale) {
    var _this;
    _classCallCheck(this, SearchResultsView);
    _this = _super.call(this, locale);
    _this.children = _this.createCollection();
    _this.focusTracker = new FocusTracker();
    _this.setTemplate({
      tag: 'div',
      attributes: {
        class: ['ck', 'ck-search__results'],
        tabindex: -1
      },
      children: _this.children
    });
    _this._focusCycler = new FocusCycler({
      focusables: _this.children,
      focusTracker: _this.focusTracker
    });
    return _this;
  }
  /**
   * @inheritDoc
   */
  _createClass(SearchResultsView, [{
    key: "render",
    value: function render() {
      _get(_getPrototypeOf(SearchResultsView.prototype), "render", this).call(this);
      var _iterator = _createForOfIteratorHelper(this.children),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var child = _step.value;
          this.focusTracker.add(child.element);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    /**
     * Focuses the view.
     */
  }, {
    key: "focus",
    value: function focus() {
      this._focusCycler.focusFirst();
    }
    /**
     * Focuses the first child view.
     */
  }, {
    key: "focusFirst",
    value: function focusFirst() {
      this._focusCycler.focusFirst();
    }
    /**
     * Focuses the last child view.
     */
  }, {
    key: "focusLast",
    value: function focusLast() {
      this._focusCycler.focusLast();
    }
  }]);
  return SearchResultsView;
}(View);
export { SearchResultsView as default };